module.exports = __webpack_public_path__ + "src/client/assets/bank-logos/pnc@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/assets/bank-logos/pnc@2x.png
// module id = 1176
// module chunks = 0